import styled from "styled-components";
import { THEME } from "../../styles/theme";
import { Fab } from "@mui/material";

export const PageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const TrainingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-bottom: 1rem;
  padding: 2rem;
  border-radius: 1.5rem;
  background-color: ${THEME.palette.background.paper};
  overflow-y: auto;
  flex: 1;
  > section {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin-bottom: 1rem;
    > button {
      text-transform: uppercase;
      min-width: auto;
    }
  }
`;
export const EditTrainingButton = styled(Fab)`
  position: absolute;
  bottom: 1.5rem;
  right: 1.5rem;
  transition: width 1s ease-in-out;
`;
